<template>
  <div>
    <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">
            Menú
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-divider></v-divider>
    <v-list>
      <v-list-tile
        value="true"
        v-for="(item, i) in items"
        :key="i"
        :to="item.route"
      >
        <v-list-tile-action>
          <v-icon light v-html="item.icon"></v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.title"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
<!--
      <div v-if="filterRole(['agremiado'])">
        <v-list-tile
          v-for="(client, i) in clients"
          :key="i"
          value="true"
          :to="client.route"
        >
          <v-list-tile-action>
            <v-icon light v-html="client.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="client.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </div>
 -->

      <!-- grupo Agremiado  -->
      <v-list-group prepend-icon="group">
        <v-list-tile slot="activator">
          <v-list-tile-title>Agremiado</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="(it, i) in clients"
          :key="i"
          :to="it.route"
          value="true"
        >
          <v-list-tile-action>
            <v-icon light v-html="it.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="it.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile value="true" @click="downloadCarnetPdf">
          <v-list-tile-action>
            <v-icon light v-html="'chrome_reader_mode'"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="'Descargar Carnet'"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
      <!-- fin grupo SisAdmin -->

      <!-- grupo SisAdmin  -->
        <!-- <v-list-group prepend-icon="traffic" v-if="filterRole(['administrador'])">
          <v-list-tile slot="activator">
            <v-list-tile-title>SisAdmin</v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            v-for="(it, i) in Sisadmin"
            :key="i"
            :to="it.route"
            value="true"
          >
            <v-list-tile-action>
              <v-icon light v-html="it.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-text="it.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group> -->
      <!-- fin grupo SisAdmin -->


      <!-- grupo Administración  -->
      <!--   <v-list-group prepend-icon="settings" v-if="filterRole(['administrador'])">
          <v-list-tile slot="activator">
            <v-list-tile-title>Administración</v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            v-for="(it, i) in Administracion"
            :key="i"
            :to="it.route"
            value="true"
          >
            <v-list-tile-action>
              <v-icon light v-html="it.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-text="it.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group> -->
      <!-- fin grupo Administración -->


      <!-- grupo Atencion Agremiado  -->
      <v-list-group prepend-icon="perm_data_setting" v-if="filterRole(['administrador'])">
        <v-list-tile slot="activator">
          <v-list-tile-title>Atención agremiado</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="(it, i) in Atencion"
          :key="i"
          :to="it.route"
          value="true"
        >
          <v-list-tile-action>
            <v-icon light v-html="it.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="it.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
      <!-- fin grupo Atención agremiado -->

      <!-- grupo cobranza  -->
      <v-list-group prepend-icon="monetization_on" v-if="filterRole(['administrador'])">
        <v-list-tile slot="activator">
          <v-list-tile-title>Cobranza</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="(it, i) in Cobranza"
          :key="i"
          :to="it.route"
          value="true"
        >
          <v-list-tile-action>
            <v-icon light v-html="it.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="it.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
      <!-- fin grupo cobranza -->


      <!-- grupo Sala Técnica  -->
      <v-list-group prepend-icon="assistant" v-if="filterRole(['administrador'])">
        <v-list-tile slot="activator">
          <v-list-tile-title>Sala Técnica</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="(it, i) in SalaTecnica"
          :key="i"
          :to="it.route"
          value="true"
        >
          <v-list-tile-action>
            <v-icon light v-html="it.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="it.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
      <!-- fin grupo Sala Técnica -->

      <!-- Respaldo final -->
      <v-list-tile :to="{ name: 'respaldo' }" value="true" v-if="filterRole(['administrador'])">
        <v-list-tile-action>
          <v-icon light>mdi-folder-download</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Respaldo</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <!-- Fin de Respaldo final -->

      <!-- grupo Ayuda  -->
      <v-list-group prepend-icon="help" v-if="filterRole(['administrador'])">
        <v-list-tile slot="activator">
          <v-list-tile-title>Ayuda</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="(it, i) in Ayuda"
          :key="i"
          :to="it.route"
          value="true"
        >
          <v-list-tile-action>
            <v-icon light v-html="it.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="it.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>


      <!-- configuracion final -->
      <v-list-tile :to="{ name: 'configuracion' }" value="true" v-if="filterRole(['administrador'])">
        <v-list-tile-action>
          <v-icon light>mdi-settings</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Configuración</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <!-- Fin de configuracion final -->

      <!-- fin grupo Sala Ayuda -->

      <!-- Ayuda final -->
      <!-- <v-list-tile
          :to="{ name: 'help' }"
          value="true"
      >
        <v-list-tile-action>
          <v-icon light>help</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Ayuda</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile> -->
      <!-- Fin de Ayuda final -->


    </v-list>


    <!-- dialog para cpc -->
<v-dialog v-model="dialogCarnetDownload" width="500" persistent>
    <v-card hover flat>
        <v-card-text>
          <div class="pa-3 pt-0 caption">
            <em>Usted no posee los siguientes requerimientos para descargar el carnet.</em>
          </div>
          <em v-if="user ? user.foto == null : ''">*Foto</em>
          <br v-if="user ? user.foto == null : ''">
          <em v-if="user ? user.firma == null : ''">*Firma</em>
          <br />
          <div class="pa-3 pt-0 caption">
            <em>Comuníquese con El Colegio de Contadores Públicos del Distrito Capital.</em>
            <em>Enviar Foto Carnet fondo rojo y firma en boligrafo negro fondo blanco al correo: agremiados_distritocapital@hotmail.com</em>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialogCarnetDownload = false" flat small color="primary">Entendido!</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
<!-- fin dialog cpc -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  computed: {
    ...mapGetters({
      user: 'authUser'
    })
  },

  mounted() {
    this.$store.dispatch('fetchUser')
  },

  data () {
    return {
      dialogCarnetDownload: false,
      name: this.$t('nav_menu_title'),
      items: [
        { title: 'Inicio', icon: 'donut_small', route: { name: 'home' }},
      ],
      clients: [
        { title: 'Cuota de Sostenimiento', icon: 'description', route: { name: 'servicios-solvencia' }},
        // { title: 'Papel de Seguridad', icon: 'description', route: { name: 'nueva-solicitud-papeles' }},
        { title: 'RAPE', icon: 'description', route: { name: 'nueva-actuacion' }},
        { title: 'Mis Actuaciones', icon: 'chrome_reader_mode', route: { name: 'mis-actuaciones' }},
        { title: 'Mis Facturas', icon: 'chrome_reader_mode', route: { name: 'mis-facturas' }},
        // { title: 'Mis Pagos', icon: 'account_balance_wallet', route: { name: 'comingsoon' }},
        { title: 'Ayuda', icon: 'help_outline', route: { name: 'help' }},
        { title: 'Documentos', icon: 'looks', route: { name: 'document-type' }},
      ],
      Ayuda: [
        { title: 'Administrador', icon: 'touch_app', route: { name: 'helpAdmin' }},
        { title: 'Metricas', icon: 'dashboard', route: { name: 'metrics' }}
      ],
      respaldo: [
        { title: 'Respaldo', icon: 'settings', route: { name: 'backup' }}
      ],
      configuracion: [
        { title: 'Configuración', icon: 'gear', route: { name: 'configuracion' }}
      ],
      SalaTecnica: [
        { title: 'Revisión',      icon: 'fingerprint', route: { name: 'ruap-revision'}},
        { title: 'Pre-aprobados', icon: 'list', route: { name: 'ruap-pre-aprobado'}},
        { title: 'Devueltos',     icon: 'pan_tool', route: { name: 'ruap-devuelto'}},
        { title: 'Aprobados',     icon: 'playlist_add_check', route: { name: 'ruap-aprobado'}}
      ],
      Atencion: [
        { title: 'Agremiados', icon: 'verified_user', route: { name: 'adminuser' }},
        // { title: 'Especialidades profesionales', icon: 'list', route: { name: 'especialidades' }},
        { title: 'Pagos', icon: 'payment', route: { name: 'pagos' }},
        { title: 'Entrega de Papel', icon: 'payment', route: { name: 'entregapapel' }},
        { title: 'Universidades', icon: 'list', route: { name: 'universities' }},
      ],
      Sisadmin: [
        { title: 'Auditoría de Sistema', icon: 'security', route: { name: 'auditoriasistema'}},
        { title: 'Permisos', icon: 'group_add', route: { name: 'permission' }},
        { title: 'Roles', icon: 'list', route: { name: 'adminroles' }},
      ],
      Administracion: [
        { title: 'Control de Cajas', icon: 'computer', route: { name: 'admincajas' }},
      ],
      Cobranza: [
        // { title: 'Categorías', icon: 'list', route: { name: 'categorias'}},
        { title: 'Conceptos', icon: 'list', route: { name: 'concepts' }},
        { title: 'Cuotas Especiales', icon: 'list', route: { name: 'cuotaespecial' }},
        { title: 'Conciliación bancaria', icon: 'account_balance', route: { name: 'conciliacion' }},
        { title: 'Cuentas por Cobrar', icon: 'account_balance', route: { name: 'cuentascobrar' }},
        // { title: 'Meses', icon: 'schedule', route: { name: 'meses'}},
        { title: 'Inventario del Papel de Seguridad', icon: 'chrome_reader_mode', route: { name: 'inventariopapel' }},
        { title: 'Tipo de actuación', icon: 'description', route: { name: 'tiposactuacion'}},
      ]
    }
  },

  methods: {

    filterRole(role) {
      let exists = false
      exists = this.user.roles.filter(rol => {
        for (let index = 0; index < role.length; index++) {
          if(rol.slug === role[index]){
            return rol
          }
        }
      }).length != 0 ? true : false

      return exists
    },

    async downloadCarnetPdf() {
      let status = this.user.foto != null &&  this.user.firma != null &&  this.user.unionize != null ? false : true
      if (status) {
        this.dialogCarnetDownload = true
      }else {
        window.location.assign(`api/agremiado/downloadCarnet/${this.user.cpc}`);
      }
    },

    // filterPermission(permission) {
    //   let exists = false
    //   exists = this.user.permissions.filter(permiss => permiss.slug === permission).length != 0 ? true : false

    //   return exists
    // }

  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/NavMenu.vue